import type { ReactElement } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { URL_ROUTES } from '@/constants';
import { PaymentLoader } from '@/modules/perseo-billing/components';
import { PaymentComplete } from '@/modules/perseo-billing/containers';
import useSetShippingAddress from '@/modules/perseo-billing/containers/payment-complete/hooks/use-set-shipping-address';
import { useSyncOrderToRedux } from '@/modules/perseo-billing/containers/payment-complete/hooks/use-sync-order-to-redux';
import { useBillingGetOrderStatus } from '@/modules/perseo-billing/hooks';
import usePreventBackNavigation from '@/modules/perseo-billing/hooks/order-confirmation/use-prevent-popstate';
import { useMazeScript } from '@/modules/perseo-billing/hooks/use-maze-script';
import useViewportMeta from '@/modules/perseo-billing/hooks/use-viewport-meta';
import { Logo } from '@/modules/perseo-billing/ui/react/src/components/beta';
import {
  isDeviceAndroid,
  isDeviceIos,
  isDeviceKiosco
} from '@/modules/perseo-billing/utils';
import { useKiosco } from '@/sections/shared/hooks/useKiosco';

export const OrderConfirmation = (): ReactElement => {
  const [searchParams] = useSearchParams({});

  const paymentSuccess = useAppSelector(
    (state) => state?.billing?.paymentSuccess
  );

  const shippingAddress = useAppSelector(
    (state) => state?.cart?.data?.shippingAddress
  );

  const orderId = searchParams.get('orderId');
  const getOrderStatus = useBillingGetOrderStatus({ orderId });
  const { data, isLoading, isSuccess } = getOrderStatus;

  useSyncOrderToRedux(data);
  useMazeScript();
  useViewportMeta();
  useKiosco();
  usePreventBackNavigation();
  useSetShippingAddress(shippingAddress);

  if (isLoading) {
    return <PaymentLoader />;
  }

  if (!paymentSuccess || !isSuccess) return <></>;

  const showHeader = !isDeviceAndroid() && !isDeviceIos() && !isDeviceKiosco();
  return (
    <div className="co-flex co-flex-col">
      {showHeader ? (
        <div className="co-w-full co-flex co-items-center co-py-8px co-px-16px co-bg-pds-primary-500 co-shadow-header lg:co-py-16px lg:co-px-64px">
          <a href={URL_ROUTES.PARIS_HOME_URL}>
            <Logo size="medium" />
          </a>
        </div>
      ) : null}
      <PaymentComplete />
    </div>
  );
};
